<template>
  <v-row class="d-flex justify-center mt-0">
    <v-col cols="12" md="3" class="py-3 px-6 px-lg-12 px-xl-16">
      <v-row class="mb-0">
        <v-col cols="4" sm="2" md="12" class="d-flex align-center pb-md-0 pb-3">
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-icon small left>fas fa-filter</v-icon>
            <span class="body-1" style="cursor: default;">
              Filtro
            </span>
          </template>
          <v-btn
            v-else
            class="text-none"
            :disabled="load"
            outlined
            text
            @click="sheet = true"
          >
            <v-icon small left>fas fa-filter</v-icon>
            Filtro
          </v-btn>
        </v-col>
        <FiltroSeleccionado
          v-model="filtro"
          @desfiltrar="desfiltrar"
        ></FiltroSeleccionado>
      </v-row>
    <v-row v-if="$vuetify.breakpoint.mdAndUp && !load">
      <Filtro
        v-model="filtro"
        :p_mas_marcas.sync="mas_marcas"
        :p_marcas.sync="marcas"
        :p_rubros.sync="rubros"
        :p_categorias.sync="categorias"
        @filtrar="filtrar"
        @desfiltrar="desfiltrar"
      ></Filtro>
    </v-row>
    <v-bottom-sheet
      v-model="sheet"
      scrollable
    >
      <v-card max-height="600">
        <v-card-title class="d-flex justify-end pa-2">
          <v-btn
            @click="sheet = false"
            small
            icon
          >
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <FiltroSeleccionado
            v-model="filtro"
            @desfiltrar="desfiltrar"
          ></FiltroSeleccionado>
          <Filtro
            v-model="filtro"
            :p_mas_marcas.sync="mas_marcas"
            :p_marcas.sync="marcas"
            :p_rubros.sync="rubros"
            :p_categorias.sync="categorias"
            @filtrar="filtrar"
            @desfiltrar="desfiltrar"
          ></Filtro>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
    </v-col>
    <v-col cols="12" md="9">
      <v-data-iterator
        v-if="!load"
        :items="arts_filtro"
        :items-per-page="vista == 0 ? 10 : 12"
        :sort-by="orden.value"
        :sort-desc="orden.desc"
        :footer-props="{
          'items-per-page-options': vista == 0 ? [ 10, 30, 50 ] : [ 12, 24, 48 ],
          'show-first-last-page': true,
          'show-current-page': true
        }"
      >
        <template v-slot:header>
          <v-row class="mb-0 mx-0">
            <v-col cols="12" class="d-flex align-center justify-end pt-0 px-0">
              <v-menu rounded="lg" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="mr-3"
                    title="Ordenar"
                    small
                    text
                  >
                    <v-icon left small>{{ orden.icon }}</v-icon>
                    {{ orden.title }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in ordenes"
                    :key="index"
                    style="cursor: pointer"
                    small
                    @click="ordenar(item)"
                  >
                    <v-list-item-title small>
                      <v-icon left small>{{ item.icon }}</v-icon>
                      {{ item.title }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn-toggle
                v-model="vista"
                mandatory
                dense
              >
                <v-btn title="Mostrar como lista">
                  <v-icon small>
                    fas fa-bars
                  </v-icon>
                </v-btn>
                <v-btn title="Mostrar como grilla">
                  <v-icon small>
                    fas fa-th
                  </v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
        </template>
        <template v-slot:default="props">
          <CardList
            v-if="vista == 0"
            v-model="props.items"
            @filtro="filtrar"
            @carrito="agregarCarrito"
          ></CardList>
          <CardGrid
            v-else
            v-model="props.items"
            @filtro="filtrar"
            @carrito="agregarCarrito"
          ></CardGrid>
        </template>
      </v-data-iterator>
      <template v-else>
        <template v-if="vista == 0">
          <v-row v-for="i in 6" :key="i" no-gutters>
            <v-col cols="4" sm="3" md="2" class="d-flex align-center justify-center">
              <v-skeleton-loader
                type="image"
                height="100"
                width="100"
              ></v-skeleton-loader>
            </v-col>
            <v-col>
              <v-skeleton-loader
                type="list-item-three-line, table-heading"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col v-for="i in 12" :key="i" cols="12" sm="6" md="4" xl="3">
              <v-skeleton-loader
                type="image"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="list-item-three-line, table-heading"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </template>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import { format_money, order_list_by } from '../../util/utils'
import CardList from '../../components/ecommerce/CardList.vue'
import CardGrid from '../../components/ecommerce/CardGrid.vue'
import Carrito from '../../components/ecommerce/Carrito.vue'
import Filtro from '../../components/ecommerce/Filtro.vue'
import FiltroSeleccionado from '../../components/ecommerce/FiltroSeleccionado.vue'

export default {
  data () {
    return {
      formatMoney: format_money,
      load: false,
      sheet: false,
      vista: 0,
      mas_marcas: false,
      filtro: [],
      marcas: [],
      rubros: [],
      categorias: [],
      orden: {},
      ordenes: [
        { icon: 'fas fa-sort-amount-down', title: 'Stock: mayor a menor', value: 'stock', desc: true },
        { icon: 'fas fa-sort-amount-down-alt', title: 'Stock: menor a mayor', value: 'stock', desc: false },
        { icon: 'fas fa-sort-numeric-down-alt', title: 'Precio: mayor a menor', value: 'precio_unitario', desc: true },
        { icon: 'fas fa-sort-numeric-down', title: 'Precio: menor a mayor', value: 'precio_unitario', desc: false },
        { icon: 'fas fa-sort-alpha-down', title: 'Producto: A-Z', value: 'articulo_nombre', desc: false },
        { icon: 'fas fa-sort-alpha-down-alt', title: 'Producto: Z-A', value: 'articulo_nombre', desc: true }
      ],
      articulos: [],
      arts_filtro: []
    }
  },
  async created () {
    this.orden = this.ordenes[0]
    this.load = true
    this.articulos = await this.$store.dispatch('ecommerce/prueba')
    this.load = false
    this.arts_filtro = this.articulos
    this.armarFiltro()
  },
  components: {
    CardList,
    CardGrid,
    Carrito,
    Filtro,
    FiltroSeleccionado
  },
  computed: {
    ...mapState(['carrito'])
  },
  methods: {
    filtrar (attr, value) {
      let existe = this.filtro.find(fto => fto.value == value && fto.type == attr)
      if (existe) {
        this.desfiltrar(existe)
        return
      }
      if (attr && value) {
        this.filtro.push({
          value: value,
          type: attr
        })
      }
      let resultante = this.articulos.filter(art => art.articulo_codigo == art.articulo_codigo)
      // si, acabo de filtrar con un 1 = 1 pq necesito todo pero si lo asigno de 1 se reemplaza x la responsibidad
      for (const filtro of this.filtro) {
        resultante = resultante.filter(art => art[filtro.type] == filtro.value)
      }
      this.arts_filtro = resultante
      this.armarFiltro()
    },
    desfiltrar (item) {
      const index = this.filtro.indexOf(item)
      this.filtro.splice(index, 1)
      this.filtrar()
    },
    agregarCarrito (item) {
      let existe = this.carrito.find(carr => carr.articulo_codigo == item.articulo_codigo)
      if (existe) {
        existe.cantidad = parseInt(existe.cantidad) + parseInt(item.cantidad)
      } else {
        this.carrito.push(JSON.parse(JSON.stringify(item)))
      }
      item.cantidad = 0
    },
    ordenar (item) {
      this.orden = item
    },
    armarFiltro () {
      this.marcas = [...new Set(this.arts_filtro.map(art => art.marca_nombre))].filter(mc => !!mc).sort()
      this.rubros = [...new Set(this.arts_filtro.map(art => art.rubro))].sort()
      this.categorias = Array.from(
        new Map(
          this.arts_filtro.map(art => [`${art.categoria}-${art.rubro}`, { categoria: art.categoria, rubro: art.rubro }])
        ).values()
      )
      order_list_by(this.categorias, 'categoria')
      this.mas_marcas = false
    }
  }
}
</script>

<style scoped>
  .scrollable-content {
    overflow-y: auto;
    max-height: 400px;
    scrollbar-width: thin;
  }
  .scrollable-content::-webkit-scrollbar {
    width: 8px;
  }
  .scrollable-content::-webkit-scrollbar-thumb {
    border-radius: 4px;
  }
</style>